import React, { MouseEvent, useState } from "react"

import { useLayerPopupContext } from "@shared/contexts"
import { setFont } from "@shared/modules"

function FontSetting() {
  const { font, close } = useLayerPopupContext()
  const fontSizeRatioOptions: FontSizeRatioOption[] = [
    { text: "가나다라마바사", value: "x-small" },
    { text: "가나다라마바사", value: "small" },
    { text: "가나다라마바사", value: "medium" },
    { text: "가나다라마바사", value: "large" },
  ]
  const [size, setSize] = useState<FontSizeRatio>(font.size)

  return (
    <>
      <article
        className="popup"
        style={{ width: "300px", margin: "-140px 0 0 -165px" }}
      >
        <div className="titB">
          <h1>폰트설정</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <ul className="radioB">
              {fontSizeRatioOptions.map((fontSizeRatioOption) => {
                return (
                  <li
                    key={fontSizeRatioOption.value}
                    style={{ fontSize: fontSizeRatioOption.value }}
                  >
                    <a
                      href="#!"
                      className={fontSizeRatioOption.value === size ? "on" : ""}
                      onClick={(e: MouseEvent) => {
                        e.preventDefault()
                        setSize(fontSizeRatioOption.value)
                      }}
                    >
                      <i>-</i>
                      {fontSizeRatioOption.text}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            className="cancel"
            title="취소"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            취소
          </a>
          <a
            href="#!"
            title="적용"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              font.handleFont({ size: size })
              setFont(size)
              close()
            }}
          >
            적용
          </a>
        </div>
      </article>
    </>
  )
}

export default FontSetting

export const ALL_FONT_SIZE_RATIOES = [
  "x-small",
  "small",
  "medium",
  "large",
] as const
type FontSizeRatioTuple = typeof ALL_FONT_SIZE_RATIOES
export type FontSizeRatio = FontSizeRatioTuple[number]

type FontSizeRatioOption = { text: string; value: FontSizeRatio }
